export default "__VITE_ASSET__da6e6982__"